module.exports = __webpack_public_path__ + "confidence.19oOZWqQ.svg";